import * as React from 'react';
import s from './InvoiceActions.scss';
import Print from 'wix-ui-icons-common/Print';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { Button, Notification } from 'wix-style-react';
import { PdfDownloader, xsrfHeaderKey, getXsrfCookie } from './PdfDownloader/PdfDownloader';
import { useState } from 'react';

export interface InvoiceActionsProps extends InjectedTranslateProps {
  withPay: boolean;
  pdfUrl: string;
  token: string;
  print(): void;
  payUrl: string;
  version: number;
  onDownloadPDF(): void;
  onPayForm?(): void;
  newMobileViewEnabled:boolean;
}

const PayForm = ({ token, t, url, version, onPayForm }) => (
  <form method="POST" action={url} onSubmit={onPayForm}>
    <Button className="pay-button" dataHook="pay-button" type="submit">
      {t('translation:invoice.actions.pay')}
    </Button>
    <input type="hidden" name="token" value={token} />
    <input type="hidden" name="version" value={version} />
    <input type="hidden" name={xsrfHeaderKey} value={getXsrfCookie()} />
  </form>
);

const InvoiceActionsComp = ({
  withPay,
  pdfUrl,
  payUrl,
  token,
  print,
  version,
  onDownloadPDF,
  t,
  onPayForm = () => {},
  newMobileViewEnabled,
}: InvoiceActionsProps) => {
  const [showError, setShowError] = useState(false);
  const withUserActions = withPay;

  return (
    <>
      <Notification autoHideTimeout={4000} theme="error" show={showError} type="sticky" onClose={() => setShowError(false)}>
        <Notification.TextLabel>{t('translation:invoice.actions.save-pdf.error')}</Notification.TextLabel>
        <Notification.CloseButton />
      </Notification>
    <div className={`${s.actions} ${withUserActions ? s.withUserActions : ''}`}>
      <div className={s.exportActions}>
        <Button theme="icon-white" dataHook="print-button" onClick={print}>
          <Print />
        </Button>
        <PdfDownloader
          text={t('translation:invoice.actions.save-pdf')}
          token={token}
          pdfUrl={pdfUrl}
          onDownloadPDF={onDownloadPDF}
          onDownloadFail={() => { setShowError(true) }}
        />
      </div>

      <div className={s.userActions}>
        {!!withPay && (
          <PayForm
            t={t}
            url={payUrl}
            token={token}
            version={version}
            onPayForm={onPayForm}
          />
        )}
          {newMobileViewEnabled && <PdfDownloader
          text={''}
          token={token}
          pdfUrl={pdfUrl}
          onDownloadPDF={onDownloadPDF}
          onDownloadFail={() => { setShowError(true) }}
          newMobileViewEnabled={newMobileViewEnabled}
        />}
      </div>
    </div>
      </>
  );
};
const InvoiceActions = translate(null, { wait: true })(InvoiceActionsComp);
export { InvoiceActions }